import React, { ReactNode, useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import { BREAKPOINTS, COLORS_BASE, STYLES } from '../../utils/consts';

type SectionContainerProps = {
  children: ReactNode,
  flex?: boolean,
  padding?: string,
  margin?: string,
  height?: string,
  width?: string,
  backgroundColor?: string,
  color?: string,
  justifyContent?: string,
  alignItems?: string,
  flexDirection?: string,
  className?: string,
  // transition?: boolean,
}

function SectionContainer({
  children,
  padding,
  margin,
  color,
  backgroundColor,
  className,
  // transition = true,
}: SectionContainerProps) {
  // const SectionContainerRef = useRef<HTMLDivElement>(null);

  return (
    <SectionContainerStyle
      // ref={SectionContainerRef}
      padding={padding} 
      margin={margin} 
      color={color} 
      backgroundColor={backgroundColor}
      className={className}
      // transition={transition}
    >
      <SectionContentStyle>
        {children}
      </SectionContentStyle>
    </SectionContainerStyle>
  )
}

export default SectionContainer;

const SectionContentStyle = styled.div<{}>(() => `
  width: min(calc(100% - 32px), 1000px);
  margin: 0 auto;
  padding: 150px 24px;
  box-sizing: border-box;

  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    width: calc(100% - 16px);
    padding: 96px 8px;
  }
`);

const SectionContainerStyle = styled.section<{ 
  padding?: string, 
  margin?: string, 
  height?: string, 
  width?: string; 
  color?: string;
  backgroundColor?: string; 
  textAlign?: string;
 }>(
  ({ 
    color = "inherit", 
    backgroundColor = "white",
    textAlign = "left",

  }) => `
  color: ${color};
  background-color: ${backgroundColor};
  width:  100%;
  pointer-events: auto;
  text-align: ${textAlign};
  position: relative;
`)